import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Spin, Input } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import lodashGet from 'lodash/get';
import { apiHolder as api, apis, getIn18Text, getFeiShuUrl, COPIED_ATTACH_KEY, } from 'api';
import classnames from 'classnames';
import IconCard from '@web-common/components/UI/IconCard';
import { formatFileSize } from '@web-common/utils/file';
import { decodeAttFileName } from '@web-common/components/util/file';
import { safeDecodeAttFileName } from '@web-common/utils/xssUtils';
import './index.scss';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { actions as attachmentActions } from '@web-common/state/reducer/attachmentReducer';
import { useNetStatus } from '@web-common/components/UI/NetWatcher';
import { ReactComponent as WifiIcon } from '@/images/icons/wifi_closed.svg';
import Alert from '@web-common/components/UI/Alert/Alert';
import { FormatExpiredDate } from '../../common/components/FormatExpireDate';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { isMainAccount, proxyImg } from '@web-mail/util';
import { IMG_TYPES } from '@web-mail/common/constant';
import { openWebPreview, buildPreviewUrl, isImage, openImgAttachment, reportAttachPreview, getAttachControlState, buildAttachPreviewContainerUrl, openAttachPreviewContainer, } from '@web-mail/utils/mailAttach';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { webTabOpen } from '@web-common/utils/utils';
import { updateCopiedAtt } from '@web-mail-write/util';
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const trackerApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const fileApi = api.api.getFileApi();
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const storeApi = api.api.getDataStoreApi();
const isExpired = (expireTime) => {
    return expireTime != null && expireTime !== 0 && expireTime < Date.now();
};
const DeleteFileAlert = (expireTime) => {
    if (isExpired(expireTime)) {
        Alert.error({
            title: getIn18Text('WENJIANBUCUNZAI'),
            content: null,
        });
        return true;
    }
    return false;
};
const AttachmentCard = props => {
    var _a;
    const { optType, file, downloadInfo, cancel, delete: deleteUpload, className, id: fileId, downloadInfoStatus, downloadInfoProcess, writeLetterProp, expired, debounceSaveDraft, seqDownload, uploadSucAutoSend, index, } = props;
    const [fileType, setFileType] = useState('');
    const [abort, setAbort] = useState();
    const abortRef = useRef(abort);
    abortRef.current = abort;
    const [operateVisible, setOperateVisible] = useState(false);
    const [processVisible, setProcessVisible] = useState(false);
    const [progress, setProcess] = useState('0%');
    const [mouseIn, setMouseIn] = useState(false);
    const [smallUrl, setSmallUrl] = useState('');
    const [backgroundStyle, setBackgroundStyle] = useState({});
    const [attStatus, setAttStatus] = useState('before');
    const attStatusRef = useRef(attStatus);
    attStatusRef.current = attStatus;
    const dispatch = useAppDispatch();
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const waittingMailIds = useAppSelector(state => state.mailReducer.waittingMailIds);
    const currentMailId = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid) || 0;
    const senderEmail = useMemo(() => (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '', [currentMailId, currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr]);
    const isMain = useMemo(() => {
        if (senderEmail === '')
            return true;
        return isMainAccount(senderEmail);
    }, [senderEmail]);
    const [fileName, setFileName] = useState('');
    const [fileSize, setFileSize] = useState(0);
    const fileRef = useRef(file);
    fileRef.current = file;
    const refCurrentMail = useRef(currentMail);
    const notShowCancelRef = useRef();
    const inputRef = useRef(null);
    notShowCancelRef.current = false;
    const [uploadedData, setUploadedData] = useState(null);
    const [previewEnabled, setPreviewEnabled] = useState(false);
    useEffect(() => {
        let alive = true;
        getAttachControlState(senderEmail)
            .then(state => {
            if (alive)
                setPreviewEnabled(state.previewEnabled);
        })
            .catch(() => { });
        return () => {
            alive = false;
        };
    }, [senderEmail]);
    const isOnline = useNetStatus();
    const paidGuideModal = useNiceModal('paidGuide');
    const queueShow = useMemo(() => {
        return optType === 'upload' && attStatus === 'uploading' && !processVisible;
    }, [optType, attStatus, processVisible, file]);
    const decodedFilename = useMemo(() => {
        try {
            const dealedName = decodeAttFileName(fileName);
            console.log('dealedName', dealedName);
            return dealedName;
        }
        catch (error) {
            return fileName;
        }
    }, [fileName]);
    const optsShow = useMemo(() => {
        return operateVisible && attStatus !== 'deleting';
    }, [attStatus, operateVisible]);
    const renameShow = useMemo(() => {
        return attStatus === 'success';
    }, [attStatus]);
    const imgIconUrl = useMemo(() => {
        if (!IMG_TYPES.includes(fileType))
            return '';
        if (downloadInfo) {
            return downloadInfo.filePreviewUrl || downloadInfo.fileUrl || '';
        }
        if (file) {
            const { file: originFile, fileUrl } = file;
            if (fileUrl)
                return fileUrl;
            if (originFile && originFile instanceof Blob) {
                try {
                    if (originFile.size < 1024 * 1024 * 1) {
                        var blob = new Blob([originFile], { type: 'text/javascript' });
                        var url = URL.createObjectURL(blob);
                        return url;
                    }
                }
                catch (error) {
                    console.log('createObjectURL error', error);
                    return '';
                }
            }
        }
        return '';
    }, [file, downloadInfo, fileType]);
    const generateSmall = useDebounceForEvent((imageUrl) => {
        console.log('generateSmall', imageUrl);
        try {
            if (!imageUrl) {
                setSmallUrl('');
                return;
            }
            const canvas = document.createElement('canvas');
            canvas.style.display = 'none';
            canvas.style.position = 'fixed';
            canvas.style.zIndex = '-9';
            canvas.style.left = '-9999px';
            document.body.appendChild(canvas);
            let img = new Image();
            img.crossOrigin = '';
            img.onload = () => {
                const { naturalWidth, width, naturalHeight, height } = img;
                const originW = naturalWidth || width;
                const originH = naturalHeight || height;
                let toW = 0;
                let toH = 0;
                if (originW > originH) {
                    toH = 42;
                    toW = Math.floor((originW / originH) * toH);
                }
                else {
                    toW = 56;
                    toH = Math.floor((originH / originW) * toW);
                }
                setBackgroundStyle({ backgroundSize: `${toW}px ${toH}px` });
                canvas.width = toW;
                canvas.height = toH;
                const ctx = canvas.getContext('2d');
                ctx && ctx.drawImage(img, 0, 0, originW, originH, 0, 0, toW, toH);
                setSmallUrl && setSmallUrl(canvas.toDataURL('image/jpeg'));
                document.body.removeChild(canvas);
                if (img)
                    img != null;
            };
            img.src = imageUrl;
        }
        catch (error) {
            console.log('generateSmall error', error);
            setSmallUrl('');
        }
    }, 150, {
        leading: false,
        trailing: true,
    });
    const generateAble = useMemo(() => {
        if (imgIconUrl && fileSize && fileSize < 1024 * 1024 * 10) {
            return true;
        }
        return false;
    }, [imgIconUrl, fileSize]);
    const attachmentType = useMemo(() => {
        var _a;
        if (optType === 'upload') {
            if (file === null || file === void 0 ? void 0 : file.cloudAttachment) {
                return 'netfolder';
            }
            if ((_a = file === null || file === void 0 ? void 0 : file.flag) === null || _a === void 0 ? void 0 : _a.usingCloud) {
                return 'netfolder';
            }
            return optType || '';
        }
        else {
            return (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.type) || '';
        }
    }, [optType, file, downloadInfo]);
    const showCloudTag = useMemo(() => {
        const isCloud = attachmentType === 'netfolder' || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudAttachment);
        if (!isCloud)
            return false;
        if (mouseIn && inElectron)
            return false;
        return true;
    }, [attachmentType, downloadInfo, mouseIn]);
    useEffect(() => {
        refCurrentMail.current = currentMail;
    }, [currentMail]);
    const uploadingStatus = () => {
        setAttStatus('uploading');
    };
    const downloadSuccess = () => {
        setProcessVisible(false);
        setAttStatus('success');
    };
    const downloadFail = () => {
        setAttStatus('error');
    };
    const uploadSuccess = useCreateCallbackForEvent((res) => {
        var _a;
        const { realId, expired, type, fileUrl } = res;
        setProcessVisible(false);
        setAttStatus('success');
        let changeData = { status: 'success' };
        if (type === 'netfolder') {
            changeData = Object.assign(Object.assign({}, changeData), { expired,
                fileUrl });
        }
        else {
            const _token = ((_a = mailConfApi.accountTokens.find(token => token.account === senderEmail)) === null || _a === void 0 ? void 0 : _a.token) || '';
            const isSubAccount = mailConfApi.isSubAccount(senderEmail);
            changeData = Object.assign(Object.assign({}, changeData), { fileUrl: proxyImg({ fileUrl, _token, isSubAccount }) });
        }
        dispatch(attachmentActions.doChangeAttachmentByRealId({ realId, data: changeData }));
    });
    const uploadFail = err => {
        if (typeof err === 'string' && ['free_version_total_size_overflow', 'free_version_attachment_size_overflow'].includes(err)) {
            paidGuideModal.show({ errType: '41', origin: '写信' });
        }
        else {
            const msg = err && err.code === 'user.cancel' ? '' : err.title || getIn18Text('FUJIANSHANGCHUANSHI');
            const errMsg = typeof err === 'string' ? err : msg;
            if (errMsg || !isOnline) {
                if (errMsg === '用户取消' && notShowCancelRef.current)
                    return;
                message.fail({
                    content: isOnline ? (errMsg) : (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                        React.createElement(WifiIcon, null),
                        React.createElement("span", { style: { marginLeft: 4 } }, getIn18Text('CAOZUOSHIBAI\uFF0C')))),
                });
            }
        }
        setAttStatus && setAttStatus('error');
        dispatch && dispatch(attachmentActions.doChangeAttachment({ id: fileId, status: 'fail', expired }));
    };
    const uploadFn = async (batch) => {
        uploadingStatus();
        if (!batch) {
            dispatch(attachmentActions.doChangeAttachment({
                id: fileId,
                status: 'uploading',
                expired,
            }));
        }
        try {
            const res = await uploadFnServer(file);
            if (!res)
                return false;
            const type = (res === null || res === void 0 ? void 0 : res.type) && res.type === 'netfolder' ? 'localCloudFile' : 'localFile';
            const value = file;
            dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, type, value, operationType: 'add' }));
            return res;
        }
        catch (error) {
            return false;
        }
    };
    const uploadFnServer = async (file) => {
        const { file: originFile, realId } = file;
        const accounts = await accountApi.getMainAndSubAccounts();
        const mainAccount = accounts[0].mainAccount;
        const sendMailId = currentMailId;
        const flag = Object.assign({}, file.flag);
        if (mainAccount !== senderEmail) {
            flag._account = senderEmail;
        }
        return mailApi
            .doUploadAttachment({
            cid: currentMailId,
            attach: originFile,
            _account: flag._account || '',
            realId,
            uploader: {
                progressIndicator: n => {
                    setAttStatus(_attrStatus => {
                        if (_attrStatus !== 'success') {
                            setProcessVisible(true);
                            setProcess(`${n * 100}%`);
                        }
                        return _attrStatus;
                    });
                },
                operatorSet: handler => setAbort(() => handler),
            },
            flag,
        })
            .then(res => {
            onUploaded(res);
            uploadSuccess(res);
            sendMailId && uploadSucAutoSend(sendMailId);
            return res;
        })
            .catch(err => {
            uploadFail(err);
        })
            .finally(() => {
            dispatch(mailActions.doUpdateWaitSave({ cid: sendMailId, val: true }));
            debounceSaveDraft && debounceSaveDraft(file === null || file === void 0 ? void 0 : file.mailId);
        });
    };
    const onUploaded = useCreateCallbackForEvent((res) => {
        if (attachPreviewType === 'web_attach') {
            res.filePreviewUrl = buildPreviewUrl(res);
            res.downloadContentId = res.contentId;
        }
        setUploadedData(res);
    });
    const actionStart = (batch) => {
        if (optType === 'upload') {
            if (!(file === null || file === void 0 ? void 0 : file.fileUrl)) {
                uploadFn(batch);
            }
            else {
                setAttStatus('success');
                dispatch(attachmentActions.doChangeAttachment({ id: file.id, status: 'success', realId: file.id, expired }));
            }
        }
    };
    const pasteActionStart = async () => {
        var _a, _b;
        const sendMailId = currentMailId;
        if (!(fileRef === null || fileRef === void 0 ? void 0 : fileRef.current))
            return;
        const curId = (_a = refCurrentMail.current) === null || _a === void 0 ? void 0 : _a.cid;
        if (!curId)
            return;
        const { attOpt, cloudAttachment, mailId, fromMailId, id, partId, fileName, fileSize, fileType, account: attAccount, realId } = fileRef.current;
        if (attOpt !== 'paste' || !!cloudAttachment)
            return;
        const _account = ((_b = refCurrentMail.current) === null || _b === void 0 ? void 0 : _b._account) || '';
        setAttStatus('generateLinking');
        dispatch(attachmentActions.doChangeAttachment({ id, status: 'uploading', expired: 0 }));
        const nowTime = new Date().getTime();
        let link = '';
        let ifGenerateNew = true;
        let copyAttId = '';
        try {
            const { suc, data: copiedDataStr } = storeApi.getSync(COPIED_ATTACH_KEY);
            try {
                if (suc && copiedDataStr) {
                    const file = JSON.parse(copiedDataStr);
                    const { generateTime: oldGenerateTime, link: oldLink } = file;
                    copyAttId = file.copyAttId;
                    if (oldGenerateTime && oldLink) {
                        if (nowTime - oldGenerateTime < 24 * 60 * 60 * 1000) {
                            ifGenerateNew = false;
                            link = oldLink;
                        }
                    }
                }
            }
            catch (error) {
                console.log('get COPIED_ATTACH error', error);
                message.error('粘贴失败');
                return;
            }
            if (!copyAttId) {
                message.error('粘贴失败');
                return;
            }
            if (ifGenerateNew) {
                const copyRes = await mailApi.writeMailCopyAttach({
                    id: file === null || file === void 0 ? void 0 : file.realId,
                    account: attAccount || '',
                    mid: fromMailId,
                    part: partId,
                    filename: fileName,
                    contentType: fileType,
                });
                const { success, message: msg, data } = copyRes;
                if (!(!!success && !!data)) {
                    message.error(msg || '获取失败');
                    downloadFail();
                    return;
                }
                link = data;
                updateCopiedAtt({ copyAttId, link, generateTime: nowTime });
            }
            link += `&random=${Math.random()}`;
            setAttStatus('pasting');
            const addDBAtt = {
                id,
                expired: 0,
                fileName,
                fileSize,
                type: 'netUrl',
                fileUrl: link,
                isCloud: false,
                downloadContentId: link,
                downloadId: link,
                realId,
            };
            console.log('addDBAtt', addDBAtt);
            await mailApi.doAddAttachment(curId, [addDBAtt], { usingCloud: false }, _account);
            const addReduxAtt = {
                id,
                mailId: curId,
                fileUrl: link,
                size: fileSize,
                fileSize,
                name: fileName,
                fileName,
                cloudAttachment: false,
                type: 'netUrl',
                status: 'success',
            };
            setAttStatus('success');
            dispatch(attachmentActions.doChangeAttachmentByRealId({ realId, data: addReduxAtt }));
            dispatch(mailActions.doChangeCacheAttachment({
                id: currentMailId,
                type: 'pasteAtt',
                value: addDBAtt,
                operationType: 'add',
            }));
            dispatch(mailActions.doUpdateWaitSave({ cid: sendMailId, val: true }));
            debounceSaveDraft && debounceSaveDraft(sendMailId);
            sendMailId && uploadSucAutoSend(sendMailId);
        }
        catch (error) {
            setAttStatus('error');
        }
    };
    const remWaittingMailId = useCreateCallbackForEvent((cond) => {
        if ((currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid) && waittingMailIds.includes(currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid)) {
            if (cond === 'abort') {
                notShowCancelRef.current = true;
            }
            dispatch(mailActions.doRemWaittingMailId(currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid));
            message.error({ content: getIn18Text('ZIDONGFASONGZHONGD，QBJWCHCXFS') });
        }
    });
    const abortPaste = () => {
        (file === null || file === void 0 ? void 0 : file.realId) && mailApi.doAbortPastingAttachment(file.realId);
        setTimeout(() => {
            var _a;
            file && ((_a = refCurrentMail === null || refCurrentMail === void 0 ? void 0 : refCurrentMail.current) === null || _a === void 0 ? void 0 : _a.cid) && dispatch(mailActions.doChangeCacheAttachment({ id: refCurrentMail.current.cid, value: file, operationType: 'delete' }));
        }, 500);
        cancel && cancel();
    };
    const actionAbort = async (fileId) => {
        var _a;
        remWaittingMailId('abort');
        if (((_a = fileRef === null || fileRef === void 0 ? void 0 : fileRef.current) === null || _a === void 0 ? void 0 : _a.attOpt) === 'paste') {
            const curStatus = attStatusRef.current;
            if (['generateLinking', 'pasting'].includes(curStatus)) {
                if (curStatus === 'pasting') {
                    SiriusMessage.error({ content: getIn18Text('QUXIAONIANTSBQDFJNTW4') });
                    return;
                }
                abortPaste();
            }
            else {
                cancel && cancel();
            }
            return;
        }
        const progressNum = progress.split('%')[0];
        if (progressNum) {
            const num = Number(progressNum);
            if (num > 95 && attStatus !== 'error') {
                SiriusMessage.error({ content: getIn18Text('QUXIAOSHANGCHUANSHIB，QDFJSCWBHSC') });
                return;
            }
        }
        if (optType === 'upload') {
            if (abort) {
                setTimeout(() => {
                    file && dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, value: file, operationType: 'delete' }));
                }, 500);
                try {
                    abort('abort');
                }
                catch (error) {
                    console.log('abort error', error);
                }
                cancel && cancel();
                return;
            }
            const abortRes = mailApi.doAbortAttachment(file.realId + '');
            const { success } = abortRes;
            if (success) {
                setProcessVisible(false);
                cancel && cancel();
            }
            else {
                cancel && cancel();
            }
        }
        else {
            setProcessVisible(false);
            setProcess('0%');
            setAttStatus('before');
            cancel && cancel();
            if (abort) {
                abort('abort');
            }
            setTimeout(() => {
                downloadInfo && dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, value: downloadInfo, operationType: 'delete' }));
            }, 500);
            dispatch(attachmentActions.doChangeAttachment({ id: fileId, status: 'before', expired }));
        }
    };
    const getSuffix = (downloadInfo) => {
        var _a;
        const type = downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileType;
        if (type && type !== 'other')
            return type;
        const arr = (_a = downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName) === null || _a === void 0 ? void 0 : _a.split('.');
        if (arr.length == 1)
            return 'other';
        return arr[arr.length - 1];
    };
    const initInfo = () => {
        remWaittingMailId();
        if (optType === 'upload') {
            const { name, fileName, size, fileSize } = file || {};
            const theName = name || fileName || 'unknown';
            setFileName(theName);
            const nameSplit = theName.split('.');
            setFileType(nameSplit[nameSplit.length - 1]);
            setFileSize(size || fileSize);
        }
        else {
            setFileType(getSuffix(downloadInfo));
            setFileName((downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName) || getIn18Text('WEIZHI'));
            setFileSize((downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize) || 0);
        }
    };
    const deleteFromForward = () => {
        mailApi.doDeleteAttachment({ cid: currentMailId, attachId: downloadInfo.id, _account: senderEmail }).then(() => {
            downloadInfo && dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, value: downloadInfo, operationType: 'delete' }));
            dispatch(attachmentActions.doChangeAttachmentAttr({
                downloadId: fileId,
                key: 'forwardWithout',
                val: true,
                expired,
            }));
            debounceSaveDraft && debounceSaveDraft(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.mailId);
        });
    };
    const renameFromForward = async (newName) => {
        const oldStatus = 'success';
        batchSetAttStatus('renameReqing');
        try {
            const res = await mailApi.doRenameAttachment({
                cid: currentMailId,
                attachId: downloadInfo.id,
                newName,
                _account: senderEmail,
            });
            const { success, code, title } = res;
            if (success) {
                batchSetAttStatus(oldStatus);
                dispatch(attachmentActions.doChangeAttachment({ id: fileId, expired, status: oldStatus, newName }));
                setFileName(newName);
                if (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSourceKey) {
                    const mailId = downloadInfo.fileSourceKey.split(';')[0];
                    dispatch(mailActions.doUpdateMailAttName({ mailId, file: Object.assign(Object.assign({}, downloadInfo), { newName }) }));
                }
                downloadInfo && dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, value: downloadInfo, operationType: 'rename', newName }));
                debounceSaveDraft && debounceSaveDraft(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.mailId);
            }
            else {
                console.error('renameFromForward fail', res);
                message.error(title || '更名失败');
                batchSetAttStatus(oldStatus);
            }
        }
        catch (error) {
            console.error('renameFromForward error', error);
            message.error('更名失败');
            batchSetAttStatus(oldStatus);
        }
    };
    const actionDelete = async () => {
        remWaittingMailId();
        if (optType !== 'upload')
            deleteFromForward();
        if (optType === 'upload') {
            const oldStatus = attStatus;
            try {
                setAttStatus('deleting');
                dispatch(attachmentActions.doChangeAttachment({ id: fileId, status: 'deleting', expired }));
                const res = await mailApi.doDeleteAttachment({ cid: currentMailId, attachId: (file === null || file === void 0 ? void 0 : file.realId) || (file === null || file === void 0 ? void 0 : file.id), _account: senderEmail });
                const { success } = res;
                if (success) {
                    dispatch(attachmentActions.doDelAttachment({ id: fileId }));
                    file && dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, value: file, operationType: 'delete' }));
                    debounceSaveDraft && debounceSaveDraft(file === null || file === void 0 ? void 0 : file.mailId);
                }
                else {
                    console.error('删除失败', res);
                    setAttStatus(oldStatus);
                    dispatch(attachmentActions.doChangeAttachment({ id: fileId, status: oldStatus, expired }));
                }
            }
            catch (error) {
                setAttStatus(oldStatus);
                dispatch(attachmentActions.doChangeAttachment({ id: fileId, status: oldStatus, expired }));
                console.error('删除失败', error);
            }
        }
    };
    useEffect(() => {
        setProcess(`${downloadInfoProcess}%`);
    }, [downloadInfoProcess]);
    useEffect(() => {
        switch (downloadInfoStatus) {
            case 'downloading':
                uploadingStatus();
                break;
            case 'success':
                downloadSuccess();
                break;
            case 'fail':
                downloadFail();
                break;
            case 'before':
                actionAbort();
                break;
        }
    }, [downloadInfoStatus]);
    useEffect(() => {
        initInfo();
        (file === null || file === void 0 ? void 0 : file.status) && setAttStatus(file.status);
        if (optType === 'upload' && (file === null || file === void 0 ? void 0 : file.status) !== 'success' && fileId) {
            let fun = actionStart;
            if ((file === null || file === void 0 ? void 0 : file.attOpt) === 'paste') {
                fun = pasteActionStart;
            }
            seqDownload({ index, fun, id: fileId });
        }
    }, [fileId]);
    useEffect(() => {
        return () => {
            var _a;
            console.log('组件销毁', file, attStatusRef.current);
            if (attStatusRef.current === 'uploading') {
                if (abortRef.current) {
                    abortRef.current('abort');
                }
                else {
                    (file === null || file === void 0 ? void 0 : file.realId) && mailApi.doAbortAttachment(file.realId + '');
                }
            }
            if (attStatusRef.current === 'generateLinking') {
                abortPaste();
            }
            ((_a = refCurrentMail === null || refCurrentMail === void 0 ? void 0 : refCurrentMail.current) === null || _a === void 0 ? void 0 : _a.cid) &&
                dispatch(mailActions.doChangeCacheAttachment({
                    id: refCurrentMail.current.cid,
                    value: file,
                    operationType: 'delete',
                }));
        };
    }, []);
    useEffect(() => {
        const { current } = inputRef;
        if (attStatus === 'renameInputting' && current) {
            try {
                current.focus();
                const nameSplit = decodedFilename.split('.');
                const suffixLen = nameSplit[nameSplit.length - 1].length;
                current.setSelectionRange(0, decodedFilename.length - suffixLen - 1);
            }
            catch (error) {
                console.error('focus error', error);
            }
        }
    }, [attStatus]);
    const openFile = async () => {
        var _a, _b, _c;
        if (optType === 'download' || !inElectron)
            return;
        if (DeleteFileAlert(expired))
            return;
        if (downloadInfo || file) {
            const info = optType === 'upload' ? file : downloadInfo;
            if (optType === 'upload') {
                const fromCloudOrWith = ['fromInternalMail', 'trs', 'netUrl'].includes(info === null || info === void 0 ? void 0 : info.type);
                let cloudOrWithInfoPath = '';
                if (fromCloudOrWith) {
                    const cloudOrWithInfo = await fileApi.getFileInfo(Object.assign(Object.assign({}, info), { _account: senderEmail }));
                    cloudOrWithInfoPath = lodashGet(cloudOrWithInfo, '[0].filePath', '');
                    if (!cloudOrWithInfoPath) {
                        setProcessVisible(true);
                        let count = 1;
                        const $t = setInterval(() => {
                            setProcess(count * 25 + '%');
                            count += 1;
                            if (count > 3) {
                                clearInterval($t);
                            }
                        }, 500);
                        const downloadRes = await fileApi
                            .download(Object.assign({}, info), { _account: senderEmail, flowScene: 'mail_write' })
                            .then(res => {
                            var _a, _b;
                            if (!((_a = res) === null || _a === void 0 ? void 0 : _a.succ) && !((_b = res) === null || _b === void 0 ? void 0 : _b.success)) {
                                trackerApi.track('pc_mail_attachment_download_failed', { type: 'res_failed', data: { req: info, res } });
                            }
                            return res;
                        })
                            .catch(e => {
                            trackerApi.track('pc_mail_attachment_download_failed', { type: 'throw_error', data: { req: info, error: e } });
                        });
                        cloudOrWithInfoPath = lodashGet(downloadRes, 'fileModel.filePath', '');
                        setProcess('100%');
                        clearInterval($t);
                        setProcessVisible(false);
                    }
                }
                fileApi
                    .openFile(Object.assign(Object.assign({}, info), { filePath: cloudOrWithInfoPath || ((_a = info === null || info === void 0 ? void 0 : info.file) === null || _a === void 0 ? void 0 : _a.electronFullPath) || ((_b = info === null || info === void 0 ? void 0 : info.file) === null || _b === void 0 ? void 0 : _b.filePath) || ((_c = info === null || info === void 0 ? void 0 : info.file) === null || _c === void 0 ? void 0 : _c.path) || (info === null || info === void 0 ? void 0 : info.reuploadLocalPath) || (info === null || info === void 0 ? void 0 : info.originalPath), _account: senderEmail }))
                    .then(bool => {
                    console.log('openFileInfo', info);
                    if (!bool) {
                        SiriusMessage.warn({ content: getIn18Text('WUFADAKAIWEN') });
                    }
                })
                    .catch(err => {
                    SiriusMessage.warn({ content: getIn18Text('WUFADAKAIWEN') });
                });
                return;
            }
            fileApi
                .getFileInfo(Object.assign(Object.assign({}, info), { _account: senderEmail }))
                .then(result => {
                if (result && result.length > 0) {
                    fileApi.openFile(Object.assign(Object.assign({}, result[0]), { _account: senderEmail })).then(bool => {
                        if (!bool) {
                            if (['trs', 'netUrl'].includes(info === null || info === void 0 ? void 0 : info.type)) {
                                SiriusMessage.warn({ content: getIn18Text('WUFADAKAIWEN12') });
                            }
                            else {
                                SiriusMessage.warn({ content: getIn18Text('WUFADAKAIWEN') });
                            }
                        }
                    });
                }
                else {
                    SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN') });
                }
            })
                .catch(err => {
                console.error(getIn18Text('DAKAIWENJIANSHI'), err);
            });
        }
        else {
            SiriusMessage.warn({ content: getIn18Text('GONGNENGCANSHUYOU') });
        }
    };
    const cloudPreview = () => {
        if (optType === 'upload' || !downloadInfo) {
            return;
        }
        reportAttachPreview({
            filename: downloadInfo.fileName,
            mid: downloadInfo.contentId || downloadInfo.downloadContentId || '',
            _account: senderEmail,
        });
        if (isImage(downloadInfo.fileName, downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileType)) {
            openImgAttachment(Object.assign(Object.assign({}, downloadInfo), { nonOriginal: true, downloadUrl: downloadInfo.fileUrl, previewUrl: downloadInfo.filePreviewUrl, name: downloadInfo.fileName, size: downloadInfo.fileSize }));
            return;
        }
        if (systemApi.isElectron() && window.electronLib) {
            const fileName = (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName) || getIn18Text('WEIZHI');
            systemApi.createWindowWithInitData('resources', {
                eventName: 'initPage',
                eventData: {
                    downloadContentId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId,
                    downloadId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId,
                    attachments: [downloadInfo],
                    fileName,
                    type: 'attachment',
                    _account: senderEmail,
                    hash: `https://resources/#type=attachment&mid=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId}&fileName=${fileName}&size=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize}&downloadId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId}&downloadContentId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId}`,
                },
            });
        }
        else {
            openWebPreview(downloadInfo, downloadInfo.downloadContentId, senderEmail);
        }
    };
    const attachPreviewType = useMemo(() => {
        var _a;
        if (process.env.BUILD_ISELECTRON && (file === null || file === void 0 ? void 0 : file.file)) {
            return 'local_attach';
        }
        if ((downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudAttachment) || ((_a = file === null || file === void 0 ? void 0 : file.flag) === null || _a === void 0 ? void 0 : _a.usingCloud) || (file === null || file === void 0 ? void 0 : file.cloudAttachment)) {
            return 'web_cloud';
        }
        return 'web_attach';
    }, [file === null || file === void 0 ? void 0 : file.cloudAttachment, downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudAttachment, (_a = file === null || file === void 0 ? void 0 : file.flag) === null || _a === void 0 ? void 0 : _a.usingCloud, file === null || file === void 0 ? void 0 : file.file]);
    const visibleNetUrl = (file === null || file === void 0 ? void 0 : file.type) === 'netUrl';
    const forwardCloudAtt = (file === null || file === void 0 ? void 0 : file.type) === 'netUrl' && (file === null || file === void 0 ? void 0 : file.cloudAttachment);
    const visibleRelateMail = (file === null || file === void 0 ? void 0 : file.type) === 'fromInternalMail';
    const isCloud = attachPreviewType === 'web_cloud';
    const visibleDownloaded = optType === 'download';
    const electronUploaded = process.env.BUILD_ISELECTRON && attStatus === 'success' && optType === 'upload';
    const visibleWebPreview = !process.env.BUILD_ISELECTRON &&
        ((optType === 'upload' && attStatus === 'success' && (!visibleNetUrl || forwardCloudAtt) && !visibleRelateMail && isMain && (file === null || file === void 0 ? void 0 : file.attOpt) !== 'paste') ||
            optType === 'download');
    const visibleElectronPreview = !!process.env.BUILD_ISELECTRON && optType === 'download';
    const visiblePreview = visibleWebPreview || visibleElectronPreview;
    const preview = () => {
        reportAttachPreview({
            filename: (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName) || fileName,
            mid: (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId) || '',
            _account: senderEmail,
        });
        if (isCloud) {
            if (process.env.BUILD_ISELECTRON && optType === 'download') {
                const filePreviewUrl = `${systemApi.getUrl('previewCloudAttGeneric')}?identity=${(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudIdentity) || ''}&p=web`;
                systemApi.createWindowWithInitData('resources', {
                    eventName: 'initPage',
                    eventData: {
                        downloadContentId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId,
                        downloadId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId,
                        attachments: [Object.assign(Object.assign({}, downloadInfo), { filePreviewUrl, from: 'netCloudAtt' })],
                        fileName,
                        type: 'attachment',
                        _account: senderEmail,
                        hash: `https://resources/#type=attachment&mid=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId}&fileName=${fileName}&size=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize}&downloadId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId}&downloadContentId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId}`,
                    },
                });
                return;
            }
            if (!process.env.BUILD_ISELECTRON) {
                let filePreviewUrl = '';
                if (uploadedData) {
                    filePreviewUrl = `${systemApi.getUrl('previewCloudAttGeneric')}?identity=${(uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.cloudIdentity) || ''}&p=web`;
                }
                else {
                    filePreviewUrl = `${systemApi.getUrl('previewCloudAttGeneric')}?identity=${(file === null || file === void 0 ? void 0 : file.id) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudIdentity) || ''}&p=web`;
                }
                webTabOpen(getFeiShuUrl(filePreviewUrl));
                return;
            }
        }
        if (optType === 'download' && !isCloud) {
            const srcMailId = (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId);
            if (previewEnabled && srcMailId) {
                openAttachPreviewContainer(buildAttachPreviewContainerUrl({ mailId: String(srcMailId), partId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.id, account: senderEmail }));
                return;
            }
            cloudPreview();
            return;
        }
        if (electronUploaded) {
            openFile();
            return;
        }
        if (visibleWebPreview && uploadedData !== null) {
            if (isImage(uploadedData.fileName, uploadedData.fileType)) {
                openImgAttachment(Object.assign(Object.assign({}, uploadedData), { nonOriginal: true, downloadUrl: uploadedData.fileUrl, previewUrl: uploadedData.fileUrl, name: uploadedData.fileName, size: uploadedData.fileSize }));
                return;
            }
            openWebPreview(uploadedData, currentMail._id, senderEmail);
            return;
        }
    };
    const rename = () => {
        setAttStatus('renameInputting');
    };
    const batchSetAttStatus = (status) => {
        setAttStatus(status);
        dispatch(attachmentActions.doChangeAttachment({ id: fileId, status, expired }));
    };
    const renameAtt = async (e) => {
        var _a;
        const newName = (((_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.value) || '').trim();
        const oldStatus = 'success';
        if (!newName) {
            message.warn({ content: '内容不能为空' });
            setAttStatus(oldStatus);
            return;
        }
        if (newName === decodedFilename) {
            setAttStatus(oldStatus);
            return;
        }
        const nameSplit = newName.split('.');
        const newType = nameSplit[nameSplit.length - 1];
        if (newType !== fileType) {
            message.warn({ content: '附件类型不能更改' });
            setAttStatus(oldStatus);
            return;
        }
        if (optType !== 'upload') {
            renameFromForward(newName);
            return;
        }
        if (optType === 'upload') {
            try {
                batchSetAttStatus('renameReqing');
                const res = await mailApi.doRenameAttachment({
                    cid: currentMailId,
                    attachId: (file === null || file === void 0 ? void 0 : file.realId) || (file === null || file === void 0 ? void 0 : file.id),
                    newName,
                    _account: senderEmail,
                });
                const { success } = res;
                if (success) {
                    batchSetAttStatus(oldStatus);
                    dispatch(attachmentActions.doChangeAttachment({ id: fileId, expired, status: oldStatus, newName }));
                    setFileName(newName);
                    file && dispatch(mailActions.doChangeCacheAttachment({ id: currentMailId, value: file, operationType: 'rename', newName }));
                    debounceSaveDraft && debounceSaveDraft(file === null || file === void 0 ? void 0 : file.mailId);
                }
                else {
                    console.error('更名请求失败', res);
                    message.error('更名失败');
                    batchSetAttStatus(oldStatus);
                }
            }
            catch (error) {
                console.error('更名失败', error);
                message.error('更名失败');
                batchSetAttStatus(oldStatus);
            }
        }
    };
    const cancelRename = (e) => {
        e.stopPropagation();
        setAttStatus('success');
    };
    const suffix = (React.createElement("span", { className: "cancel-rename", onClick: cancelRename }, getIn18Text('QUXIAO')));
    const onMouseLeave = () => {
        setOperateVisible(false);
        setMouseIn(false);
    };
    const onMouseEnter = () => {
        setOperateVisible(true);
        setMouseIn(true);
    };
    const onMouseOver = () => {
        setOperateVisible(true);
    };
    return (React.createElement("div", { className: `attachment-card ${attStatus === 'error' ? 'error' : ''} ${className}`, onClick: () => {
            if (visiblePreview || electronUploaded) {
                preview();
            }
        }, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, onMouseOver: onMouseOver },
        React.createElement("div", { className: "content" },
            showCloudTag ? React.createElement("div", { className: classnames('netfolder-tag', { invisible: optsShow }) }, getIn18Text('YUNFUJIAN')) : '',
            React.createElement("div", { className: "info-icon" },
                React.createElement(IconCard, { type: fileType, height: "18", width: "18" })),
            React.createElement("div", { className: "info-right" }, ['renameInputting', 'renameReqing'].includes(attStatus) ? (React.createElement("div", { className: classnames('rename', attStatus === 'renameReqing' ? 'reqing' : '') },
                React.createElement(Input, { ref: inputRef, defaultValue: decodedFilename || '', className: "rename-input", suffix: suffix, onPressEnter: renameAtt, onBlur: renameAtt, onClick: e => e.stopPropagation() }))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "info" },
                    React.createElement("div", { className: "info-cont" },
                        React.createElement("div", { className: `info-name ${['error', 'uploading', 'generateLinking', 'pasting', 'before'].includes(attStatus) ? 'info-opacity' : ''} `, title: decodeAttFileName(fileName), dangerouslySetInnerHTML: { __html: safeDecodeAttFileName(fileName) } }),
                        queueShow && React.createElement("div", { className: classnames('queue-tag', { invisible: optsShow }) }, getIn18Text('ZHENGZAIPAID')),
                        ['generateLinking', 'pasting'].includes(attStatus) && React.createElement("div", { className: classnames('queue-tag') }, getIn18Text('ZHENGZAINIANTZ')))),
                React.createElement("div", { className: "operate" },
                    React.createElement("div", { className: classnames('operate-item', { 'operate-gap': inElectron }) },
                        React.createElement("div", { className: classnames('size', { invisible: optsShow }), hidden: attStatus === 'deleting' },
                            (attachmentType === 'netfolder' || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudAttachment)) && attStatus === 'success' ? (React.createElement(React.Fragment, null,
                                React.createElement(FormatExpiredDate, { date: expired }),
                                ' | ')) : (''),
                            fileSize > 0 ? formatFileSize(fileSize, 1024) : getIn18Text('WEIZHIDAXIAO')),
                        attStatus === 'deleting' && (React.createElement("span", { className: classnames('att-deleting', { invisible: optsShow }) },
                            getIn18Text('SHANCHUZHONG'),
                            React.createElement(Spin, null))),
                        React.createElement("div", { hidden: !optsShow, className: "item-box" },
                            visiblePreview && (React.createElement("span", { className: "item-ope", onClick: e => {
                                    e.stopPropagation();
                                    preview();
                                } }, getIn18Text('YULAN'))),
                            (attStatus === 'success' || optType === 'download') && (React.createElement("span", { className: "item-ope", onClick: e => {
                                    e.stopPropagation();
                                    actionDelete();
                                } }, getIn18Text('SHANCHU'))),
                            attStatus === 'error' && (React.createElement("span", { className: "item-ope", onClick: e => {
                                    e.stopPropagation();
                                    if ((file === null || file === void 0 ? void 0 : file.attOpt) === 'paste') {
                                        pasteActionStart();
                                    }
                                    else {
                                        actionStart();
                                    }
                                } }, getIn18Text('ZHONGSHI'))),
                            ['uploading', 'error', 'generateLinking', 'pasting'].includes(attStatus) && (React.createElement("span", { className: "item-ope", onClick: e => {
                                    e.stopPropagation();
                                    actionAbort();
                                } }, getIn18Text('QUXIAO'))),
                            electronUploaded && (React.createElement("span", { className: "item-ope", onClick: e => {
                                    e.stopPropagation();
                                    preview();
                                } }, getIn18Text('DAKAI'))),
                            renameShow && (React.createElement("span", { className: "item-ope", onClick: e => {
                                    e.stopPropagation();
                                    rename();
                                } }, getIn18Text('ZHONGMINGMING')))))))))),
        React.createElement("div", { className: `process-box ${processVisible ? '' : 'hide'}` },
            React.createElement("div", { className: "process", style: { width: progress } }))));
};
export default AttachmentCard;
